/* Current Nostalgia - v1.23: small behaviour fixes from the Oct 31 mobile UX audit.
   Focus rings after a tap: Dawn hands focus back to the menu button (and the Filter and sort button)
   when a drawer closes, and the browser then draws a keyboard-style focus ring around it even though
   the drawer was closed with a finger. When that focus arrives shortly after a tap and no key was
   pressed since, the button is blurred; keyboard users keep the ring. */
(function () {
  if (window.__cnV123) return;
  window.__cnV123 = true;
  var lastPointer = 0, lastKey = 0;
  window.addEventListener('pointerdown', function () { lastPointer = Date.now(); }, true);
  window.addEventListener('keydown', function () { lastKey = Date.now(); }, true);
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('summary.header__icon, summary.mobile-facets__open-wrapper, .mobile-facets__open')) return;
    if (lastPointer > lastKey && Date.now() - lastPointer < 2500) {
      setTimeout(function () { if (document.activeElement === t) t.blur(); }, 0);
    }
  }, true);
})();

/* v1.28: the cart's free-shipping bar ("You're $X away from free US shipping") is US-only.
   cn-ux.js measures the cart total in the shopper's own currency against 15000, so a shopper outside
   the US with a PHP 3,800 cart was told they had unlocked free US shipping. Outside the US, or when
   not paying in USD, the message and progress track are hidden; the shipping note under them stays. */
(function () {
  if (window.__cnV127) return;
  window.__cnV127 = true;
  var S = window.Shopify || {};
  var cur = S.currency && S.currency.active;
  if (S.country === 'US' && (!cur || cur === 'USD')) return;
  document.documentElement.classList.add('cn-intl');
  var st = document.createElement('style');
  st.textContent = '.cn-intl .cn-ship__msg, .cn-intl .cn-ship__track { display: none !important; }';
  document.head.appendChild(st);
})();
